<template>
  <LineChart :chart-data="datacollection" :min-val="minVal" :max-val="maxVal" class="chart"></LineChart>
</template>

<script>
import LineChart from "../../util/LineChart";
import convertDate from "../../util/convertDate";

export default {
  name: "Chart",
  data: () => ({
    dateLabels: [],
    values: [],
    standardValues: [],
    datacollection: null
    // minVal: null,
    // maxVal: null
  }),
  created() {
    this.processData();
  },
  mounted() {
    this.fillData();
  },
  methods: {
    fillData() {
      this.datacollection = {
        labels: this.dateLabels,
        datasets: [
          {
            borderColor: "#000000",
            pointBorderColor: "#000000",
            pointBackgroundColor: "#000000",
            backgroundColor: "transparent",
            borderWidth: 1,
            data: this.values
          },
          {
            borderColor: "red",
            pointBorderColor: "rgba(0,0,0,0)",
            pointBackgroundColor: "rgba(0,0,0,0)",
            backgroundColor: "transparent",
            borderWidth: 2,
            data: this.standardValues
          }
        ]
      };
    },
    processData() {
      // 「エコポイント」と「水温・水質」で場合分け
      if (!this.qualityName) {
        for (let data of this.fetchedData) {
          console.log("チームとかのfetchedData", this.fetchedData);
          const slashDate = convertDate.convertSlashDate(data.created_at);
          this.dateLabels.push(slashDate);
          this.values.push(data.point);
        }
      } else {
        for (let data of this.fetchedData) {
          const slashDate = convertDate.convertSlashDate(data.checked_at);
          this.dateLabels.push(slashDate);
          switch (this.qualityName) {
            case "WT":
              this.values.push(data.water_temperature);
              this.standardValues.push(24.5);
              this.minVal = 20;
              this.maxVal = 30;
              break;
            case "PH":
              this.values.push(data.ph);
              this.standardValues.push(8);
              this.minVal = 5;
              this.maxVal = 10;
              break;
            default:
              console.log("qualityName", this.qualityName);
              break;
          }
        }
      }
    }
  },
  components: {
    LineChart
  },
  props: ["fetchedData", "qualityName"]
};
</script>

<style scoped>
@media screen and (max-width: 350px) {
  .chart {
    height: 250px;
    width: 280px !important;
  }
}
@media screen and (min-width: 351px) and (max-width: 767px) {
  .chart {
    height: 250px;
    width: 370px !important;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .chart {
    height: 400px;
    width: 700px !important;
  }
}
@media screen and (min-width: 1024px) {
  .chart {
    height: 500px;
    width: 800px !important;
  }
}
</style>
